<template>
  <!-- paypal核对 -->
  <div class="opage">
    <div>
      <!-- paypal核对 -->
      <baseBreadcrumb :page="`商品跟进页面-${japanUserRoleStatus}`" :menu="$t('message.orderForm')"></baseBreadcrumb>
      <div class="tabs">
        <el-tabs v-model="datas.status" type="card" @tab-click="tabClick">
          <!--  全部商品-->
          <el-tab-pane :label="`等待采购`" name="等待采购"></el-tab-pane>
          <el-tab-pane :label="`待改价`" name="待改价"></el-tab-pane>
          <el-tab-pane :label="`等待财务付款`" name="等待财务付款"></el-tab-pane>
          <el-tab-pane :label="`待发货`" name="待发货"></el-tab-pane>
          <el-tab-pane :label="`已发货`" name="已发货"></el-tab-pane>
          <el-tab-pane :label="`已签收`" name="已签收"></el-tab-pane>
          <el-tab-pane :label="`核查中`" name="核查中"></el-tab-pane>
          <el-tab-pane :label="`待检品`" name="待检品"></el-tab-pane>
          <el-tab-pane :label="`检品中`" name="检品中"></el-tab-pane>
          <el-tab-pane :label="`检品完了`" name="检品完了"></el-tab-pane>
          <el-tab-pane :label="`上架中`" name="上架中"></el-tab-pane>
          <el-tab-pane :label="`上架完了`" name="上架完了"></el-tab-pane>
          <el-tab-pane :label="`问题产品`" name="问题产品"></el-tab-pane>
        </el-tabs>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 超过上架天数 -->
          <!-- 2023/8/23 大谢说那边还没定好,先不显示这个 -->
          <!-- <el-select v-model="datas.dayNum" placeholder="">
            <el-option label="3天" value=""></el-option>
            <el-option label="5天" value=""></el-option>
            <el-option label="10天" value=""></el-option>
            <el-option label="15天" value=""></el-option>
            <el-option label="20天" value=""></el-option>
            <el-option label="30天" value=""></el-option>
          </el-select> -->
          <!-- 物流号 -->
          <div class="item">
            <!-- 搜索内容 -->
            <el-input v-model="datas.express_no" placeholder="请输入物流号" clearable>
            </el-input>
          </div>
          <!-- 交易号 -->
          <div class="item">
            <!-- 搜索内容 -->
            <el-input v-model="datas.purchase_no" placeholder="请输入交易号" clearable>
            </el-input>
          </div>
          <!-- 订单号 -->
          <div class="item">
            <!-- 搜索内容 -->
            <el-input v-model="datas.order_sn" placeholder="请输入订单号" clearable>
            </el-input>
          </div>
          <!-- 客户ID -->
          <div class="item">
            <!-- 搜索内容 -->
            <el-input v-model="datas.user_id" placeholder="请输入客户ID" clearable>
            </el-input>
          </div>
          <!-- 商品ID -->
          <div class="item">
            <!-- 搜索内容 -->
            <el-input v-model="datas.goods_id" placeholder="请输入商品ID" clearable>
            </el-input>
          </div>
          <!-- 管理番号 -->
          <div class="item">
            <!-- 搜索内容 -->
            <el-input v-model="datas.for_sn" placeholder="管理番号" clearable>
            </el-input>
          </div>
        </div>
        <div class="row">
          <!-- 业务 -->
          <div class="item">
            <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
              <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 采购 -->
          <div class="item">
            <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
              <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 配货员 -->
          <div class="item">
            <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
              <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
          </div>
          <!-- 客户属性 -->
          <div class="item">
            <el-select v-model="datas.attribute" clearable filterable :placeholder="$t('message.customerProperty')">
              <el-option v-for="item in vipList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!--是否有问题产品 -->
          <div class="item">
            <el-select v-model="datas.problemProduct" clearable filterable
              :placeholder="$t('message.isThereAProblemWithTheProduct')">
              <el-option label="是" :value="1">
              </el-option>
              <el-option label="否" :value="2">
              </el-option>
            </el-select>
          </div>
          <!-- 是否紧急 -->

          <!-- <div class="item"
            v-if="datas.status == '等待采购' || datas.status == '待发货' || datas.status == '已发货' || datas.status == '检品中' || datas.status == '检品完了'">
            <el-select v-model="datas.overdue" :placeholder="$t('message.isOverdue')" filterable clearable
              @change="$forceUpdate()">
              <el-option :label="$t('message.all')" value="0">
              </el-option>
              <el-option :label="$t('message.overdue')" value="1">
              </el-option>
            </el-select>
          </div> -->
          <!-- <div class="item"> -->
          <!--  全体人员-->
          <!-- <el-select v-model="datas.admin_id" :placeholder="$t('message.specificPersonnel')" filterable clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select> -->
          <!-- </div> -->
          <!-- 核对 -->
          <el-button type="primary" @click="search"> 筛选 </el-button>
          <!-- 操作 -->
          <!-- <div class="operation"> -->
          <!-- 问题产品 -->
          <!-- <el-button type="primary" @click="problemStore"> {{ $t('message.Problem') }} </el-button> -->
          <!-- </div> -->
        </div>
      </div>
      <div class="body">
        <!-- :style="`height:${tableautoheight}px`" -->
        <div class="scrollBox">
          <div class="table">
            <ol>
              <li class="flex05">NO</li>
              <li class="flex05">
                <el-checkbox v-model="checked" @change="allChecked"></el-checkbox>
              </li>
              <!-- 入金时间 -->
              <li class="time" v-if="['等待采购', '待改价', '等待财务付款'].indexOf(datas.status) !== -1">入金时间</li>
              <!-- 入金确认时间 -->
              <li class="time">入金确认时间</li>
              <!-- 标记待改价 -->
              <!-- <li class="time">标记待改价</li> -->
              <!-- 财务付款时间 -->
              <li class="time" v-if="datas.status == '待发货'">财务付款时间</li>
              <!-- 商品发货时间 -->
              <li class="time" v-if="datas.status == '已发货' || datas.status == '已签收'">商品发货时间</li>
              <!-- 商品收货时间 -->
              <li class="time" v-if="datas.status == '已签收'">商品收货时间</li>
              <!-- 开始核查时间 -->
              <li class="time" v-if="datas.status == '待检品'">开始核查时间</li>
              <!-- 开始检品时间 -->
              <li class="time" v-if="datas.status == '检品中' || datas.status == '检品完了'">开始检品时间</li>
              <!-- 检品完了时间 -->
              <li class="time"
                v-if="datas.status == '检品完了' || datas.status == '上架中' || datas.status == '上架完了' || datas.status == '问题产品'">
                检品完了时间
              </li>
              <!-- 上架完了时间 -->
              <!-- <li class="time">上架完了时间</li> -->
              <!-- 交易号 -->
              <li>交易号</li>
              <!-- 物流号 -->
              <li>物流号</li>
              <!-- 订单号 -->
              <li class="flex15">订单号</li>
              <!-- 装箱详情 -->
              <li class="flex2">装箱详情</li>
              <!-- 操作员 -->
              <li class="flex15">操作员</li>
              <!-- 番号 -->
              <li class="flex05">番号</li>
              <!-- 照片 -->
              <li>照片</li>
              <!-- 数量 -->
              <li>数量</li>
              <!-- 属性 -->
              <li>属性</li>
              <!-- 类型 -->
              <li>类型</li>
              <!-- 业务商品备注 -->
              <li>业务商品备注</li>
              <!-- 采购商品备注 -->
              <li>采购商品备注</li>
              <!-- 配货商品备注 -->
              <li>配货商品备注</li>
              <!-- 业务跟单备注 -->
              <li class="flex2">业务跟单备注</li>
              <!-- 业务内部跟单备注 -->
              <li class="flex2">业务内部跟单备注</li>
              <!-- 采购跟单备注 -->
              <li class="flex2">采购跟单备注</li>
              <!--  配货跟单备注-->
              <li class="flex2">配货跟单备注</li>
            </ol>
            <ul v-for="(item, index) in tableData" :key="index">
              <li class="flex05 rowNumber">
                {{ item.rowNumber }}
                <el-popover placement="top-end" width="350" trigger="hover">
                  <div v-for="(problem_goods) in item.problem_goods">
                    <p>问题提出时间：{{ problem_goods.created_at }}</p>
                    <p>问题类别：{{ problem_goods.type_name }}</p>
                    <p>具体问题描述：{{ problem_goods.description }}</p>
                  </div>
                  <router-link
                    :to="'/pre-saleProblem?order_sn=' + item.order_sn + '&status=' + item.problem_goods[item.problem_goods.length - 1].status"
                    target="_blank" v-if="item.problem_goods != false && item.problem_goods != null" slot="reference">问
                  </router-link>
                </el-popover>
              </li>
              <li class="flex05">
                <div>
                  <p v-if="item.order.user.authorized" class="authorized">授权</p>
                  <el-popover placement="right" title="合计" width="200" trigger="focus">
                    <statistics :checkedList="checkedList" />
                    <el-checkbox v-model="item.checked" @change="changeChecked" slot="reference"></el-checkbox>
                  </el-popover>
                </div>
              </li>
              <!-- 入金时间 -->
              <li class="time" v-if="['等待采购', '待改价', '等待财务付款'].indexOf(datas.status) !== -1" @click="getAllTime(item)">
                {{ getTime("已支付待确认到账",
                  item) }}</li>
              <!-- 入金确认时间 -->
              <li class="time" @click="getAllTime(item)">{{ getTime("已到账待采购", item) }}</li>
              <!-- 标记待改价 -->
              <!-- <li class="time">{{ getTime("提交到待改价", item) }}</li> -->
              <!-- 财务付款时间 -->
              <li class="time" v-if="datas.status == '待发货'" @click="getAllTime(item)">{{ getTime("待发货", item) }}</li>
              <!-- 商品发货时间 -->
              <li class="time" v-if="datas.status == '已发货' || datas.status == '已签收'" @click="getAllTime(item)">{{
                getTime("已发货", item) }}</li>
              <!-- 商品收货时间 -->
              <li class="time" v-if="datas.status == '已签收'">{{ getTime("已签收（收货员扫描物流号）", item) }}</li>
              <!-- 开始核查时间 -->
              <li class="time" v-if="datas.status == '待检品'" @click="getAllTime(item)">{{ getTime("核查中（拆包时间）", item) }}
              </li>
              <!-- 开始检品时间 -->
              <li class="time" v-if="datas.status == '检品中' || datas.status == '检品完了'" @click="getAllTime(item)">{{
                getTime("检品中", item) }}</li>
              <!-- 检品完了时间 -->
              <li class="time"
                v-if="datas.status == '检品完了' || datas.status == '上架中' || datas.status == '上架完了' || datas.status == '问题产品'"
                @click="getAllTime(item)">{{
                  getTime("检品完了", item) }}</li>
              <!-- 上架完了时间 -->
              <!-- <li class="time">{{ getTime("上架完了", item) }}</li> -->
              <!-- 交易号 -->
              <li>
                <div>
                  <p class="authorized">
                    {{ item.order_box_status }}
                  </p>
                  <p v-for="purItem in item.purchase_no" :key="purItem">
                    {{ purItem }}
                  </p>
                </div>
              </li>
              <!-- 物流号 -->
              <li>
                <div>
                  <div v-for="express in item.express_no" :key="express"
                    @click="domesticLogisticsTracking(item.purchase_no, item.from_platform, express)">
                    <div>
                      <el-popover placement="left" title="国内物流:" width="500" trigger="click">
                        <el-timeline v-if="activities != false" style="max-height: 500px; overflow-y: auto;">
                          <el-timeline-item v-for="(activity, index) in activities" :key="index"
                            :timestamp="activity.time" :color="activity.color" placement="top">
                            {{ activity.address }}
                          </el-timeline-item>
                        </el-timeline>
                        <p v-else> 暂无物流信息 </p>
                        <p slot="reference">
                          <span class="WL">
                            <a href="javascript:;" class="a-link">
                              {{ express }}
                            </a>
                            <i class="el-icon-copy-document" @click.stop="copy(express)"></i></span>
                        </p>
                      </el-popover>
                    </div>
                  </div>
                </div>
                <!-- <div>
                  <p v-for="expItem in item.express_no" :key="expItem">
                    {{ expItem }}
                  </p>
                </div> -->
              </li>
              <!-- 订单号 -->
              <li class="flex15">
                <div>
                  <!-- 供应商订单标识 -->
                  <p v-if="item.order_extend">
                    <el-tag size="mini" type="primary" class="primary" effect="dark"
                      v-if="item.order_extend.is_supplier_order">供应商订单</el-tag>
                  </p>
                  <p>

                    <router-link
                      :to="'/user/basicInformation?userID=' + item.order.user.id + '&encryption=' + $md5(item.order.user.id + '')"
                      target="_blank" class="a-link">
                      {{ item.order.user.realname }}
                    </router-link>

                  </p>
                  <attributeName :name="item.attribute_name" />
                  <!-- 手机下单标记 -->
                  <span v-if="item.order.from_tool != 1" style="vertical-align: middle;"><img
                      src="@/assets/icon/mobile.png" alt="" style="width: 25px;"></span>
                  <router-link :to="'/orderDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">
                    {{ item.order_sn }}</router-link>
                  <!-- 聊天 -->
                  <a :href="'https://www.chatwork.com/#!rid' + item.order.user.chatwork" target="_blank"
                    v-if="item.order.user.chatwork"> <img src="@/assets/user/CW.svg" alt=""
                      style="vertical-align: middle;">
                  </a>
                  <span style="cursor: pointer;" @click="chat(item)" v-else>
                    <img src="@/assets/user/raku.svg" alt="">
                  </span>
                </div>
              </li>
              <!-- 装箱详情 -->
              <li class="flex2">
                <div class="template order_no attribute">
                  <p v-for="(box, boxIndex) in item.order_box_detail" :key="boxIndex">
                    <router-link :to="`/boxDetail?id=${box.order_box.id}&verification=${$md5(box.order_box.id + '')}`"
                      target="_blank" class="a-link" style="display: inline;">
                      {{ box.order_box.order_sn }}-{{ box.order_box.box_no }}</router-link>
                    -<span v-if="box.order_box.status == 0">(装箱中)</span>
                    <span v-else-if="box.order_box.status == 1">(已完成)</span>
                    <span v-else-if="box.order_box.status == 2">(已提出配送单)</span>
                  </p>
                </div>
              </li>
              <!-- 操作员 -->
              <li class="flex15">
                <div>
                  <p>业务:{{ item.order.y_admin ? item.order.y_admin.realname : '' }}</p>
                  <p>采购:{{ item.order.g_admin ? item.order.g_admin.realname : '' }}</p>
                  <p>配货:{{ item.order.g_admin ? item.order.p_admin.realname : '' }}</p>
                </div>
              </li>
              <!-- 番号 -->
              <li class="flex05">{{ item.sorting }}</li>
              <!-- 照片 -->
              <li>
                <div>
                  {{ item.order.type_name }}
                  <el-popover placement="right" trigger="hover">
                    <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                    <a :href="item.link" target="_blank" rel="noopener noreferrer" slot="reference">
                      <el-image class="goodsImg" :src="item.pic">
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                        <div slot="placeholder">
                          <i class="el-icon-loading"></i>
                        </div>
                      </el-image>
                    </a>
                  </el-popover>
                  <el-input size="mini" placeholder="管理番号" v-model="item.for_sn" style="padding: 0;"
                    @blur="batchUpdateOrderDetailForSn(item)" v-if="isAuth(579)"></el-input>
                  <p v-else>{{ item.for_sn }}</p>
                </div>

              </li>
              <!-- 数量 -->
              <li>
                <div>
                  <p>
                    <span>可入库:</span><span>{{ item.possible_num }}</span>
                  </p>
                  <p>
                    <span>已到货:</span><span>{{ item.storage_num }}</span>
                  </p>
                  <p>
                    <span>已出货:</span><span>{{ item.delivery_num }}</span>
                  </p>
                </div>
              </li>
              <!-- 属性 -->
              <li>
                <el-popover placement="bottom" width="400" trigger="click">
                  <div>
                    <p v-for="(detailItem, detailIndex) in item.detail_y" :key="detailIndex">
                      <b> {{ detailItem.key }}</b>: {{ detailItem.value }}
                    </p>
                  </div>

                  <div slot="reference" class="goodsDetail">
                    <p v-for="(detailItem, detailIndex) in item.detail_y" :key="detailIndex">
                      <b> {{ detailItem.key }}</b>: {{ detailItem.value }}
                    </p>
                  </div>
                </el-popover>
              </li>
              <!-- 类型 -->
              <li>
                <div>
                  <p>类型:{{ item.from_platform }}</p>
                  <p>商品ID:{{ item.goods_id }}</p>
                </div>
              </li>
              <!-- 业务商品备注 -->
              <li>
                <el-popover placement="bottom" width="400" trigger="click">
                  <p>{{ item.y_remark }}</p>
                  <div class="remarkShow" slot="reference">
                    {{ item.y_remark }}
                  </div>
                </el-popover>
              </li>
              <!-- 采购商品备注 -->
              <li>
                <el-popover placement="bottom" width="400" trigger="click">
                  <p>{{ item.g_remark }}</p>
                  <div class="remarkShow" slot="reference">
                    {{ item.g_remark }}
                  </div>
                </el-popover>
              </li>
              <!-- 配货商品备注 -->
              <li>
                <el-popover placement="bottom" width="400" trigger="click">
                  <p>{{ item.p_remark }}</p>
                  <div class="remarkShow" slot="reference">
                    {{ item.p_remark }}
                  </div>
                </el-popover>
              </li>
              <!-- 业务跟单备注 -->
              <li class="flex2" @dblclick="itemRemarkShow(item, 'y_remark_show')">

                <el-input type="textarea" :readonly="japanUserRoleStatus != '业务' || item.y_remark_show"
                  v-model="item.order_detail_follow_remark.y_remark" resize="none"
                  @change="setUpBusinessTrackingNotes(item, item.order_detail_follow_remark.y_remark,)"
                  placeholder="当前备注会同步给客户，请填写日语。" :title="item.order_detail_follow_remark.y_remark">
                </el-input>
              </li>
              <li class="flex2" @dblclick="itemRemarkShow(item, 'y_remark_inside_show')">
                <el-input type="textarea" :readonly="japanUserRoleStatus != '业务' || item.y_remark_inside_show"
                  v-model="item.order_detail_follow_remark.y_remark_inside" resize="none"
                  @change="updateFollowYRemarkInside(item, item.order_detail_follow_remark.y_remark_inside, 'y_remark_inside_show')"
                  placeholder="该备注仅供内部查看" :title="item.order_detail_follow_remark.y_remark_inside">
                </el-input>
              </li>
              <!-- 采购跟单备注 -->
              <li class="flex2" @dblclick="itemRemarkShow(item, 'g_remark_show')">
                <el-input type="textarea" :readonly="japanUserRoleStatus != '采购' || item.g_remark_show"
                  v-model="item.order_detail_follow_remark.g_remark" resize="none"
                  @change="setUpProcurementTrackingNotes(item, item.order_detail_follow_remark.g_remark, 'g_remark_show')"
                  :title="item.order_detail_follow_remark.g_remark">
                </el-input>
              </li>
              <!-- 配货跟单备注 -->
              <li class="flex2" @dblclick="itemRemarkShow(item, 'p_remark_show')">
                <el-input type="textarea" :readonly="japanUserRoleStatus != '配货' || item.p_remark_show"
                  v-model="item.order_detail_follow_remark.p_remark" resize="none"
                  @change="updateFollowPRemark(item, item.order_detail_follow_remark.p_remark, 'p_remark_show')"
                  :title="item.order_detail_follow_remark.p_remark">
                </el-input>
              </li>
            </ul>
            <!-- 暂无数据 -->
            <div v-if="tableData == false" class="No_data">
              {{ $t("message.noDataYet") }}
            </div>
          </div>
        </div>
        <!-- 操作 -->
        <div class="operation">
          <!-- 同ID商品 -->
          <el-button size="small" type="primary" class="primary" @click="productWithTheSameId">
            {{ $t('message.productWithTheSameId') }}
          </el-button>
          <!-- 复制 -->
          <el-button size="small" type="primary" @click="copyProduct">
            {{ $t('message.copy') }}
          </el-button>
        </div>
        <!-- 分页 -->
        <div class="paginationContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="datas.page" :page-sizes="[50, 100, 200]" :page-size="datas.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 往上 -->
      <el-backtop :bottom="70" :right="10">
        <div class="up">
          <i class="el-icon-arrow-up"></i>
        </div>
      </el-backtop>
      <!-- 往下 -->
      <div class="bottom" @click="toBottom">
        <i class="el-icon-arrow-down"></i>
      </div>
    </div>
    <!-- 查看全部时间 -->
    <allTime ref="allTime" :node_list="node_list" />
  </div>
</template>

<script>
import statistics from './statistics'
import { vipList } from '@/utlis/options'
import allTime from './allTime'
export default {
  components: {
    statistics,
    allTime,
  },
  metaInfo: {
    title: "商品跟进",
  },
  data() {
    return {
      vipList,
      checkedList: [],// 计算用
      datas: {
        status: "等待采购",
        org_id: "",
        admin_id: "",
        pageSize: 50,
        page: 1,
        overdue: ''
      }, //动态调整表格高度
      checked: false,
      japanUserRoleStatus: "",
      trackingNotes: "",
      tableautoheight:
        window.innerHeight > 500 ? window.innerHeight - 258 : 800,
      tableData: [],
      userList: [],
      tabs: [],
      total: 0,
      activities: [],
      node_list: [],//全部时间
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  created() {
    let query = this.$route.query
    if (query.status) {
      this.datas.status = query.status
    }
    if (query.overdue) {
      this.datas.overdue = query.overdue
    }
    if (query.user_id) {
      this.datas.user_id = query.user_id
    }
    this.$store.dispatch("getAuthWorkGroupAdmin");
    this.$store.dispatch("getOrganizationList");
    // this.datas.start_time = getCurrentMonthFirst();
    // this.datas.end_time = getCurrentMonthLast();
    let reda = localStorage.getItem("japanUserRoleStatus"); //1=业务员,2=采购
    switch (reda) {
      case "1":
        this.japanUserRoleStatus = "业务";
        break;
      case "2":
        this.japanUserRoleStatus = "采购";
        break;
      case "5":
        this.japanUserRoleStatus = "配货";
        break;
      default:
        break;
    }
    // this.sortingTrackingListTabNum();
    this.sortingTrackingList();
  },
  mounted() {
    window.onresize = () => {
      this.tableautoheight =
        window.innerHeight > 500 ? window.innerHeight - 258 : 800;
    };
  },
  methods: {
    toBottom() {
      var osTop = 0
      let timer = setInterval(function () {
        var body = document.querySelector('body')
        var detailHeight = body.scrollHeight
        let ispeed = Math.floor(detailHeight / 5);
        osTop += ispeed
        window.scrollTo(0, osTop)
        if (osTop >= detailHeight) {
          clearInterval(timer);
        }
      }, 50);
    },
    // 设置业务跟单备注
    setUpBusinessTrackingNotes(item, remark) {
      item.y_remark_show = true
      this.$api.orderApi
        .updateFollowYRemark({ order_detail_id_set: [item.id], y_remark: remark })
        .then((res) => {
          ////console.log('事件名',res)
          if (res.code != 0)
            return this.$message.error(res.msg);
          //接下来的操作
        });
    },
    // 修改内部业务跟进备注
    updateFollowYRemarkInside(item, remark, type) {
      item[type] = true
      this.$api.orderApi
        .updateFollowYRemarkInside({ order_detail_id_set: [item.id], y_remark_inside: remark })
        .then((res) => {
          ////console.log('事件名',res)
          if (res.code != 0)
            return this.$message.error(res.msg);
          //接下来的操作
        });
    },
    // 设置采购跟单备注
    setUpProcurementTrackingNotes(item, remark, type) {
      item[type] = true
      this.$api.orderApi
        .updateFollowGRemark({ order_detail_id_set: [item.id], g_remark: remark })
        .then((res) => {
          ////console.log('事件名',res)
          if (res.code != 0)
            return this.$message.error(res.msg);
          //接下来的操作
        });
    },
    // 设置配货跟单备注
    updateFollowPRemark(item, remark, type) {
      item[type] = true
      this.$api.orderApi
        .updateFollowPRemark({ order_detail_id_set: [item.id], p_remark: remark })
        .then((res) => {
          ////console.log('事件名',res)
          if (res.code != 0)
            return this.$message.error(res.msg);
          //接下来的操作
        });
    },
    // 从时间列表中查找出对应的时间
    getTime(type, item) {
      let returnData = item.node_list.find((listItem) => {
        return listItem.name == type;
      });
      return (returnData || {}).datetime;
    },
    tabClick() {
      // this.sortingTrackingListTabNum();
      this.sortingTrackingList();
    },
    // 获取相应标签的数量
    getTabsNum(v) {
      let data = this.tabs.find((item) => {
        return item.name == v;
      });
      return (data || { num: 0 }).num;
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.admin_id = "";
    },
    // 获取标签数量
    sortingTrackingListTabNum() {
      this.$api.orderApi.sortingTrackingListTabNum().then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(this.$fanyi(res.msg));
        //接下来的操作
        this.tabs = res.data;
      });
    },
    // 重置
    reset() {
      this.datas = {};
      this.datas.express_no = "";
      this.status = "";
      this.sortingTrackingList();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.sortingTrackingList();
    },
    // 获取列表
    sortingTrackingList() {
      let returnDatas = JSON.parse(JSON.stringify(this.datas));
      if (!returnDatas.admin_id) {
        delete returnDatas.admin_id;
      }
      if (!returnDatas.org_id) {
        delete returnDatas.org_id;
      }
      this.tableData = []
      this.$api.orderApi.sortingTrackingList(returnDatas).then((res) => {
        if (res.code != 0) return this.$message.error(res.data.msg);
        res.data.data.forEach((dateItem) => {
          dateItem.y_remark_show = true
          dateItem.g_remark_show = true
          dateItem.y_remark_inside_show = true
          dateItem.p_remark_show = true
          dateItem.checked = false
          if (!dateItem.order_detail_follow_remark) {
            dateItem.order_detail_follow_remark = {
              y_remark: "",
              g_remark: "",
            };
          }
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.sortingTrackingList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.sortingTrackingList();
    },
    // 获取物流信息
    //获取国内物流轨迹
    domesticLogisticsTracking(purchase_no, from_platform, express_no) {
      let datas = {
        purchase_no: purchase_no[0],
        from_platform,
        express_no
      }
      this.activities = []
      this.$api.domesticLogisticsTracking(datas).then(res => {
        if (res.data.all_adress != false) {
          res.data.all_adress[0].color = '#B4272D'
        }
        this.activities = res.data.all_adress
      })
    },
    // 提出问题产品
    problemStore() {
      let datas = {
        order_purchase_id: [],
        order_detail_id: [],
        inspect_detail_id: [],
        status: [],
      };
      let order_sn = [];
      this.tableData.forEach((item) => {
        if (item.checked) {
          datas.order_purchase_id.push(item.id);
          datas.order_detail_id.push(item.order_detail.id);
          order_sn.push(item.order_sn);
          datas.status.push(items.order_detail.statusName);
        }
      });

      if (datas.order_purchase_id == false)
        return this.$message.error(
          this.$t("message.selectableOperationalList")
        );
      order_sn = Array.from(new Set(order_sn));
      // 问题产品提出需要限制单次只能单个订单的商品一起提出问题产品
      if (order_sn.length > 1)
        return this.$message.error(this.$t("message.danGeDanDingDan"));
      this.$store.dispatch("getProblemList", datas);
      this.checked = false;
      // this.allChecked();
    },
    // 全选
    allChecked() {
      this.tableData.forEach(item => {
        item.checked = this.checked
      })
      this.changeChecked()
    },
    //单选
    changeChecked() {
      this.checked = this.tableData.every(item => item.checked)
      this.checkedList = []
      this.tableData.forEach(item => {
        if (item.checked) {
          this.checkedList.push(item)
        }
      })
    },
    // 问题产品提交成功
    problemStoreSuccess() {
      this.purchaseList();
    },
    //同ID商品
    productWithTheSameId() {
      this.checkedList.forEach(item => {
        this.tableData.forEach(items => {
          if (item.goods_id == items.goods_id) {
            items.checked = true
          }
        })
      })
    },
    // 复制商品信息
    copyProduct() {
      let value = ''
      this.checkedList.forEach(item => {
        if (this.japanUserRoleStatus != '采购') {
          value += `${item.order_sn}\n${item.sorting}番  ${item.link} \n${item.purchase_no != false ? '交易号: ' + item.purchase_no[0] : ''}\n 客户名：${item.order.user.realname}\n`
        } else {
          let size = ''
          item.detail_y.forEach(items => {
            size += `${items.key}:${items.value}  `
          })
          // 采购
          value += `${size}\n数量:${item.possible_num}\n${item.order_sn}\n${item.sorting}番  链接:${item.link} \n${item.purchase_no != false ? '交易号: ' + item.purchase_no[0] : ''}\n`
        }
      })
      this.copy(value)
    },
    //打开聊天
    chat(item) {
      let japanUserRoleInfo = JSON.parse(localStorage.getItem('japanUserRoleInfo'))
      let token = localStorage.getItem('japan_access_token')
      let iTop = (window.screen.availHeight - 30 - 700) / 2;
      //获得窗口的水平位置
      let iLeft = (window.screen.availWidth - 10 - 1260) / 2;
      if (location.host.indexOf('.co.jp') == -1) {
        window.open(
          `https://rakuchat.rakumart.com/admin_web/#/?id=JP${japanUserRoleInfo.id}&uid=${item.order.user.id}&token=${token}`,
          japanUserRoleInfo,
          "height=700, width=1260, left=" +
          iLeft +
          ", top=" +
          iTop +
          ", toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no"
        );
      }
    },
    //获取全部时间
    getAllTime(item) {
      this.node_list = [item.node_list]
      this.$refs.allTime.dialogVisible = true
    },
    // 备注可隐藏
    itemRemarkShow(item, type) {
      item[type] = false
      this.$forceUpdate()
    },
    //订单-修改管理番号
    batchUpdateOrderDetailForSn(item) {
      let datas = {
        order_detail_id_set: [item.id],
        for_sn: item.for_sn
      }
      this.$api.orderApi.batchUpdateOrderDetailForSn(datas)
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

/deep/ .is-disabled {
  .el-textarea__inner {
    background-color: #fff;
    color: #606266;
  }
}

.opage {
  min-width: 1910px;
}

.tabs {
  padding: 0 30px;
}

.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.search {
  margin: 24px 0;
  padding: 0 30px;


  /deep/.el-input__inner {
    width: 240px;
  }

  .row {
    display: flex;
    margin-bottom: 16px;
    position: relative;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }


}

.table {
  // min-width: 220000px;
  font-size: 12px;
  text-align: center;

  ol {
    position: sticky;
    top: 0px;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;


    li {
      height: 40px;
      text-align: center;
      align-items: center !important;

    }
  }

  li {
    flex: 1.2;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
    word-break: break-all;

    &:nth-last-child(1) {
      margin-right: 0;
    }

    .authorized {
      font-size: 14px;
      color: #b4272d;
      margin-bottom: 5px
    }
  }

  .time {
    max-width: 63px;
  }

  .flex05 {
    flex: 0.6;
    position: relative;

    a {
      position: absolute;
      right: 0;
      top: 0;
      height: 20px;
      width: 20px;
      background-color: #f56c6c;
      border-radius: 50%;
      line-height: 20px;
      text-align: center;
      color: #fff;
    }
  }

  .flex15 {
    flex: 1.5;
  }

  .flex2 {
    flex: 2;
  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;
    cursor: pointer;
    // height: 100px;

    &:hover {
      background-color: #fff;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }

    /deep/.el-textarea__inner {
      padding: 3px;
      height: 100px;
    }
  }

  .goodsImg {
    width: 60px;
    height: 60px;
  }

  .goodsDetail {
    cursor: pointer;
    // text-overflow: -o-ellipsis-lastline;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-line-clamp: 4;
    // -webkit-box-orient: vertical;
  }

  .remarkShow {
    cursor: pointer;
    max-height: 160px;
    overflow: hidden;
    // text-overflow: -o-ellipsis-lastline;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-line-clamp: 3;
    // -webkit-box-orient: vertical;
  }
}

.keHu {
  p {
    text-align: center;
  }
}

.lookMore {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.body {
  position: relative;

  .operation {
    position: sticky;
    bottom: 0;
    left: 0;
    background-color: #edeff4;
    padding: 10px;
    height: 30px;
    width: 100%;
    z-index: 9;

  }
}

.bottom {
  height: 40px;
  width: 40px;
  background-color: #b4272d;
  box-shadow: 0 0 6px rgba(0, 0, 0, .12);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: fixed;
  right: 10px;
  bottom: 20px;
  cursor: pointer;
  z-index: 999;

  i {
    font-size: 20px;
    color: #fff;
  }
}
</style>
